import styled from 'styled-components';

export const FormBand = styled.div`
  background-color: #e9ecf3;
`;

/** Mirrors the source's `a-col :xs="24" :lg="is_webview ? 24 : 14"` inside a centered flex row. */
export const FormWrapper = styled.div<{ $fullWidth?: boolean }>`
  width: 100%;
  margin: 0 auto;
  padding: 40px 0;

  @media only screen and (max-width: 575px) {
    padding: 30px 0;
  }

  @media only screen and (min-width: 1024px) {
    width: ${(props) => (props.$fullWidth ? '100%' : '58.333333%')};
  }
`;

export const FormHeader = styled.div`
  display: flex;
  justify-content: center;

  font-weight: 700;
  font-size: 24px;
  color: #1e242f;
  text-align: center;
`;

export const FormFields = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  padding: 30px 0 20px;

  @media only screen and (min-width: 576px) {
    gap: 20px;
    padding: 40px 0 30px;
  }

  > div {
    @media only screen and (max-width: 575px) {
      grid-column: span 2;
    }
  }

  /* Seven fields in a two-column grid leaves one orphan; let it fill the row. */
  > div:last-child {
    @media only screen and (min-width: 576px) {
      grid-column: span 2;
    }
  }
`;

/** Matches the antd field metrics from the source: 40px tall, 1.5px border, 6px radius. */
export const FormItem = styled.div`
  padding: 0;
  margin: 0;

  .MuiOutlinedInput-root {
    height: 40px;
    border-radius: 6px;
    background-color: #fff;
    font-weight: 500;
    font-size: 14px;
  }

  .MuiOutlinedInput-notchedOutline {
    border-width: 1.5px;
  }

  /*
    The app theme zeroes the outline on every TextField (theme.config.tsx:143-187), which the
    Select is not subject to. Restore it here so the two controls match.
  */
  .MuiTextField-root .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
    border: 1.5px solid rgba(0, 0, 0, 0.23) !important;
    border-radius: 6px !important;
  }

  /* Without this the rule above would also out-specify the theme's teal focus ring. */
  .MuiTextField-root
    .MuiOutlinedInput-root:hover
    .MuiOutlinedInput-notchedOutline,
  .MuiTextField-root
    .MuiOutlinedInput-root.Mui-focused
    .MuiOutlinedInput-notchedOutline {
    border: 1px solid #31acbf !important;
  }

  .MuiOutlinedInput-input {
    padding: 12px 16px;
  }

  .MuiSelect-select {
    display: flex;
    align-items: center;
  }
`;

export const PlaceholderText = styled.span`
  color: #a8b5c9;
  font-weight: 500;
  font-size: 14px;
`;

export const SubmitButton = styled.button<{ $loading?: boolean }>`
  width: 100%;
  height: 40px;
  padding: 8px 16px;

  font-weight: 700;
  font-size: 14px;
  color: #ffffff;

  border: none;
  border-radius: 6px;
  cursor: ${(props) => (props.$loading ? 'default' : 'pointer')};
  background-color: ${(props) =>
    props.$loading ? 'rgba(49, 172, 191, 0.5)' : '#31acbf'};

  &:hover {
    background-color: ${(props) =>
      props.$loading ? 'rgba(49, 172, 191, 0.5)' : 'rgba(49, 172, 191, 0.75)'};
  }
`;

export const SuccessImage = styled.img`
  width: 100%;
  aspect-ratio: calc(500 / 282);
  object-fit: cover;
  display: block;
`;

export const SuccessBody = styled.div`
  position: relative;
  padding: 20px;
  padding-top: 43px;
  text-align: center;
`;

export const SuccessIconWrapper = styled.div`
  position: absolute;
  top: -28px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;

  svg {
    aspect-ratio: 1;
    width: 56px;
    height: 56px;
  }
`;

export const SuccessTitle = styled.p`
  margin-bottom: 5px;
  font-weight: 500;
  font-size: 1rem;
  color: #1e242f;
`;

export const SuccessCaption = styled.p`
  font-weight: 500;
  font-size: 14px;
  color: #67708c;
  text-align: center;
  margin: 0;
`;
